module.exports = __webpack_public_path__ + "img/1970East-007_WEB-min.d2063ddd.jpg";